<div class="teacher-app-popover">
  <div>
      <button (click)='commands.gotoVideoLibraryPage(this)'>Video Library</button>
      <button (click)='commands.gotoParentEducationPage(this)'>PEM Library</button>
      <button (click)='commands.gotoTeachingToolsPage(this)'>Teaching Tools</button>
      <button (click)='commands.gotoTrainingPage(this)'>Trainings/Workshops</button>
      <ng-container *ngFor='let page of resourcePages(); trackBy: trackByUuid'>
        <button (click)='commands.gotoPagesPage(this, page)'>{{page.title}}</button>
      </ng-container>
  </div>
</div>